<template>
    <div class="sidebarMain">
        <div class="sidebarSty" @click="secEvent('/courseServer/personalLearning')"
            :class='{ secActive: clickIndex == "/courseServer/personalLearning" }'>
            <span>{{ $t('course.courseText22') }} </span>
            <span class="lineSy">-</span>
        </div>
        <div class="sidebarSty" @click="secEvent('/courseServer/teamLearning')"
            :class='{ secActive: clickIndex == "/courseServer/teamLearning" }'>
            <span>{{ $t('course.courseText23') }} </span>
            <span class="lineSy">-</span>
        </div>
        <div class="sidebarSty" @click="secEvent('/courseServer/accompanyRunners')"
            :class='{ secActive: clickIndex == "/courseServer/accompanyRunners" }'>
            <span>{{ $t('course.courseText24') }} </span>
            <span class="lineSy">-</span>
        </div>
        <div class="sidebarSty" @click="secEvent('/courseServer/lead')" :class='{ secActive: clickIndex == "/courseServer/lead" }'>
            <span>{{ $t('course.courseText25') }} </span>
            <span class="lineSy">-</span>
        </div>
        <div class="sidebarSty" @click="secEvent('/courseServer/onLine')" :class='{ secActive: clickIndex == "/courseServer/onLine" }'>
            <span>{{ $t('course.courseText26') }} </span>
            <span class="lineSy">-</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        secValue: {
            type: String,
            default: '/courseServer/personalLearning'
        },
        senMessage: {
            type: Function,
            require: false, // 定义参数是否必须值
        },

    },
    data() {
        return {
            clickIndex: this.secValue,
        }
    },
    watch: {
        '$route'(to, from) {
            this.clickIndex = to.fullPath
        }
    },
    created() {
        console.log(' this.$router', this.$router)
        this.clickIndex = this.$route.path
    },
    methods: {
        secEvent(val) {
            this.clickIndex = val
            // this.$emit('senMessage', val)
            this.$router.push(val)
        }
    },
}
</script>
<style lang="scss" scoped>
.sidebarMain {
    background: #555555;
    height: 100%;
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
    padding: 36px 20px 0 20px;
    width: 240px;

    .sidebarSty {
        width: 200px;
        // height: 28px;

        border-radius: 4px;
        line-height: 28px;
        padding: 0 20px;
        margin-bottom: 18px;
        ;
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        &:hover {
            background: #D31319;
        }

        .lineSy {
            display: flex;
            align-items: center;
        }
    }

    .secActive {
        background: #D31319;
    }
}
</style>
 


// WEBPACK FOOTER //
// src/components/sidebar.vue